// extracted by mini-css-extract-plugin
module.exports = {"OSDToolbar":"dxV","icon":"dxW","withSpacer":"dxX","roundedUp":"dxY"};